'use client';

import {
  ReactNode
} from 'react';

import {
  useScrollReveal
} from '@/app/hooks/use-scroll-reveal';

import {
  useCountUp
} from '@/app/hooks/use-count-up';

interface StatItemProps {
  value: string
  label: string
  icon: ReactNode
}

export default function StatItem({
  value, label, icon
}: StatItemProps) {

  const {
    ref, isVisible
  } = useScrollReveal<HTMLDivElement>();

  // Splits "600+" into a numeric part to count up and a suffix to keep
  // static - falls back to rendering the raw value if it isn't numeric.
  const match = value.match(/^(\d+)(.*)$/);
  const target = match ? Number(match[1]) : null;
  const suffix = match ? match[2] : '';
  const count = useCountUp(target ?? 0, isVisible);

  return (
    <div
      ref={ref}
      className={`text-center transition-all duration-500 ${ isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4' }`}
    >
      {icon}
      <p className="text-4xl sm:text-5xl font-bold text-white mb-2">
        {target !== null ? `${ count }${ suffix }` : value}
      </p>
      <p className="text-white/80 text-sm font-medium">{label}</p>
    </div>
  );
}
